import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import {
  bulkPaymentUploadFailure,
  bulkPaymentUploadReq,
  bulkPaymentUploadSuccess,
} from 'redux/slice/allocation/BulkPayment.slice';
import {
  BulkPaymentUploadRequest,
  BulkPaymentUploadResponse,
} from 'redux/types/Allocation.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* bulkPaymentUpload({
  payload,
}: PayloadAction<BulkPaymentUploadRequest>) {
  try {
    const { paymentFile, allocatorId, fileType, filterType } = payload;

    const formData = new FormData();
    formData.append('paymentFile', paymentFile);
    formData.append('allocatorId', allocatorId);
    formData.append('fileType', fileType);
    formData.append('filterType', filterType);

    const response: { data: BulkPaymentUploadResponse } =
      yield HTTPClient.PostRequest(
        allocationEndpoints.BULK_PAYMENT_UPLOAD(allocatorId),
        formData
      );

    yield put(bulkPaymentUploadSuccess(response.data));
    message.success(
      response.data?.message || 'Payment file uploaded successfully'
    );
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Bulk payment upload failed';
    yield put(bulkPaymentUploadFailure(errorMessage));
    message.error(errorMessage);
  }
}

export function* watchBulkPaymentSagas() {
  yield takeLatest(bulkPaymentUploadReq.type, bulkPaymentUpload);
}
